import { inventoryPresentation } from "../pages/inventoryIntelligenceMessages";

const es = {
  "Purchases grouped by item for the selected dates. Open movements to review the delivery notes.": "Compras agrupadas por artículo en el periodo seleccionado. Abre los movimientos para revisar los albaranes.",
  "Consumption view": "Vista del consumo",
  "Consumed quantity": "Cantidad consumida",
  "Weighted unit cost": "Coste unitario medio",
  "Last purchase": "Última compra",
  "Unassigned location": "Sin ubicación asignada",
  "View movements": "Ver movimientos",
  "View movements for {0}": "Ver movimientos de {0}",
};

export function directConsumptionPresentation(languageId) {
  const presentation = inventoryPresentation(languageId);
  return {
    ...presentation,
    t: (key, values = {}) => {
      const translated = languageId === "es" ? es[key] : undefined;
      return translated === undefined ? presentation.t(key, values)
        : translated.replace(/\{(\w+)\}/g, (match, name) => values[name] ?? match);
    },
  };
}
